import ApplePass from "components/apple-pass";
import GooglePass from "components/google-pass";
import { useAuth } from "context/auth";

function FallbackCard({ title = "Cardly", subtitle = "Digital card preview" }) {
  return (
    <div className="tw-rounded-[28px] tw-bg-[#2C3255] tw-p-6 tw-text-white">
      <div className="tw-flex tw-items-center tw-gap-3">
        <span className="tw-inline-block tw-h-3 tw-w-3 tw-rounded-full tw-bg-[#F35658] tw-shadow-[14px_0_0_#FAD845]" />
        <span className="tw-text-lg tw-font-semibold">Cardly</span>
      </div>
      <div className="tw-mt-14 tw-space-y-2">
        <p className="tw-text-xs tw-uppercase tw-tracking-[0.24em] tw-text-white/60">Preview ready</p>
        <p className="tw-text-3xl tw-font-semibold tw-tracking-tight">{title}</p>
        <p className="tw-text-sm tw-text-white/70">{subtitle}</p>
      </div>
      <div className="tw-mt-14 tw-rounded-[22px] tw-bg-white/10 tw-p-5">
        <div className="tw-grid tw-grid-cols-2 tw-gap-3">
          <div className="tw-h-16 tw-rounded-2xl tw-bg-white/10" />
          <div className="tw-h-16 tw-rounded-2xl tw-bg-white/10" />
        </div>
      </div>
    </div>
  );
}

export default function AdminPassPreview(props) {
  const { preview } = props;
  const { currentUser } = useAuth();
  const shouldUseCurrentUserFallback = !Object.prototype.hasOwnProperty.call(props, "preview");
  const API_URL = process.env.REACT_APP_API_URL || "";
  const uploadsBaseUrl = API_URL.replace(/\/api\/?$/, "").replace(/\/$/, "");

  const resolveAsset = (value) => {
    if (!value || typeof value !== "string") return "";
    if (
      value.startsWith("data:") ||
      value.startsWith("blob:") ||
      value.startsWith("http://") ||
      value.startsWith("https://")
    ) {
      return value;
    }
    if (value.startsWith("/uploads/")) {
      return `${uploadsBaseUrl}${value}`;
    }
    if (value.includes("/uploads/")) {
      return `${uploadsBaseUrl}/uploads/${value.split("/uploads/").pop()}`.replace(/([^:]\/)\/+/g, "$1");
    }
    return `${uploadsBaseUrl}/uploads/${value}`;
  };

  const resolvedPreview = preview || (shouldUseCurrentUserFallback && currentUser?.design ? {
    passType: currentUser.passType,
    design: {
      ...currentUser.design,
      firstName: currentUser.firstName,
      lastName: currentUser.lastName,
      fullName: `${currentUser.firstName || ""} ${currentUser.lastName || ""}`.trim(),
      jobTitle: currentUser.jobTitle,
      email: currentUser.email,
      phone: currentUser.phone,
      phones: currentUser.phones,
      prefix: currentUser.prefix,
      organisationName: currentUser.account?.organizationName,
      companyURL: currentUser.account?.companyURL,
      linkedInURL: currentUser.account?.linkedInURL,
      addresses: currentUser.addresses || [],
      socials: currentUser.socials || [],
      personalAccount: currentUser.account?.type === "personal",
    },
    values: { prefix: currentUser.prefix },
  } : null);

  if (!resolvedPreview?.design) {
    return (
      <FallbackCard
        title={
          resolvedPreview?.design?.fullName ||
          `${currentUser?.firstName || "Cardly"} ${currentUser?.lastName || "User"}`.trim()
        }
        subtitle={resolvedPreview?.design?.organisationName || currentUser?.account?.organizationName || "Cardly workspace"}
      />
    );
  }

  const rawPassType = String(resolvedPreview.passType || "APPLE").toUpperCase();
const passType =
  rawPassType === "ANDROID" ? "GOOGLE" :
  rawPassType === "IOS" ? "APPLE" :
  rawPassType;
  const normalizedPreview = {
    ...resolvedPreview,
    design: {
      ...resolvedPreview.design,
      logoImage: resolveAsset(resolvedPreview.design?.logoImage),
      stripImage: resolveAsset(resolvedPreview.design?.stripImage),
    },
  };

  return (
    <div className="tw-flex tw-justify-center">
      {passType === "GOOGLE" ? (
        <GooglePass design={normalizedPreview.design} values={normalizedPreview.values} />
      ) : (
        <ApplePass design={normalizedPreview.design} values={normalizedPreview.values} />
      )}
    </div>
  );
}
